import { useIntl } from 'react-intl';

import { IconArrowRight } from '@xing-com/icons';
import { LightMode } from '@xing-com/theme-mode-switcher';

import { setShowNotEnoughProfileError } from '../../apollo';

import { useSearchBar } from './hooks';
import { LocationInput } from './location-input';
import { QueryInput } from './query-input';
import * as S from './search-bar.styles';

export const SearchBar: React.FC = () => {
  const { formatMessage } = useIntl();
  const {
    keywords,
    onChangeKeywords,
    location,
    onChangeLocation,
    onSelectLocation,
    isLocationDisabled,
    onSubmit,
  } = useSearchBar();

  const handleOnSubmit = (event: React.FormEvent<HTMLFormElement>): void => {
    event.preventDefault();
    setShowNotEnoughProfileError(false);
    onSubmit();
  };

  const onMouseDown = (event: React.MouseEvent<HTMLButtonElement>): void => {
    // Prevents the textarea from shrinking (losing focus) when the button is
    // clicked, so we can perform a search
    event.preventDefault();
  };

  return (
    <S.Container>
      <LightMode>
        <S.Form
          onSubmit={handleOnSubmit}
          // FIXME: action="." is needed to show the search button on the iOS keyboards: https://stackoverflow.com/a/26287843}
          action="."
        >
          <QueryInput
            value={keywords}
            onChangeKeywords={onChangeKeywords}
            onSubmit={onSubmit}
          />
          <S.Divider />
          <S.LocationFieldsWrapper>
            <LocationInput
              value={location}
              onChangeLocation={onChangeLocation}
              onSelectLocation={onSelectLocation}
              isLocationDisabled={isLocationDisabled}
            />
            <S.SubmitButton
              variant="tertiary"
              size="small"
              type="submit"
              icon={IconArrowRight}
              aria-label={formatMessage({ id: 'JOBS_FIND_JOBS_SEARCH_BUTTON' })}
              onMouseDown={onMouseDown}
            />
          </S.LocationFieldsWrapper>
        </S.Form>
      </LightMode>
    </S.Container>
  );
};
